import React from 'react';
import Tasks from './components/tasks';
import Layout from '@/common/Layout';
import FloatingActionButton from '../FloatingActionButton';
import { getLoggedInUser } from 'utilities/helpers';
const AllEmployeeTasks = () => {
  const user = getLoggedInUser();
  return (
    <Layout sider={false}>
      <Tasks />
      {/* {user?.user_details?.role_id === 1 ? <FloatingActionButton /> : ''} */}
    </Layout>
  );
};

export default AllEmployeeTasks;
